export default {"src":"/_next/static/media/mana20.1ff00686.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};